type Stage = 'development' | 'test' | 'uat' | 'production'

export const STAGE: Stage = (import.meta.env.VITE_STAGE as Stage) || 'development'

console.log('STAGE 2025-12-17', STAGE)

// 默认各阶段的 API 基地址（按需修改）
const DEFAULT_API_BASE_URLS: Record<Stage, string> = {
  development: 'https://app-api-test2.yayya.live',
  test: 'https://app-api-test2.yayya.live',
  uat: 'https://app-api-uat.yayya.live',
  production: 'https://app-api.yayya.live',
}

// 默认各阶段的 Scene 基地址
const DEFAULT_SCENE_URLS: Record<Stage, string> = {
  development: 'https://test-scene.yayya.live',
  test: 'https://test-scene.yayya.live',
  uat: 'https://test-scene.yayya.live',
  production: 'https://scene.yayya.live',
}

// 开发环境使用本地代理，解决跨域问题
// 生产环境直接使用原始 API 地址
const getApiBaseUrl = (): string => {
  const isDev = import.meta.env.DEV
  if (isDev && STAGE === 'development') {
    // 开发环境使用本地代理路径
    return '/api/proxy'
  }
  return DEFAULT_API_BASE_URLS[STAGE]
}

// 统一使用代码内映射，避免外部环境变量干扰导致意外指向生产
export const API_BASE_URL = getApiBaseUrl()
export const SCENE_URL = import.meta.env.VITE_SCENE_URL || DEFAULT_SCENE_URLS[STAGE]

// 便捷标识
export const IS_DEV = STAGE === 'development'
export const IS_TEST = STAGE === 'test'
export const IS_PROD = STAGE === 'production'
